import axios from "axios";
import AppStateHOC from "../lib/app-state-hoc.jsx";
import { resetSession } from "../reducers/user-info";
import { isUserLogin, getCookie } from "../lib/tool";
import pubSub from "../lib/pub-sub";
import { envConfigs } from "./config.js";

const noNeedLoginURL = [
    "/index/mc/sps3/backdrop",
    "/index/mc/sps3/sprite",
    "/index/mc/sps3/costume",
    "/index/mc/sps3/sound",
    "/index/mc/custom",
    "/index/vcShareProjectController/getCustomerProjectDetail",
    "/workspace/sb2",
];

const checkRequestURL = (url) =>
    !!noNeedLoginURL.find((item) => url.includes(item));

const axiosInstance = axios.create();

axiosInstance.defaults.withCredentials = true;
const CancelToken = axios.CancelToken;
const source = CancelToken.source();

// 改成根據 domain 和品牌來切換
let baseUrl = envConfigs.apiUrl;

// switch (process.env.NODE_ENV) {
//     case 'production':
//         baseUrl = 'https://programming.tutorjr.com';
//         break;
//     case 'pre':
//         baseUrl = 'https://pre-programming.tutorjr.com';
//         break;
//     case 'development':
//         baseUrl = 'https://stage-programing.tutorjr.com';
//         break;
//     default:
//         baseUrl = 'https://programming.tutorjr.com';
// }

// 请求拦截器
axiosInstance.interceptors.request.use(
    function (config) {
        const { url = "" } = config;
        const {
            scratchGui: {
                mode: { isPlayerOnly },
            },
        } = AppStateHOC.store.getState();
        if (!isUserLogin() && !isPlayerOnly && !checkRequestURL(url)) {
            AppStateHOC.store.dispatch(resetSession({}));
            config.cancelToken = source.token;
            source.cancel("用户登录信息失效！");
            pubSub.publish("login");
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

// 響應攔截器
axiosInstance.interceptors.response.use(
    function (response) {
        return response;
    },
    function (error) {
        const { response = {} } = error;
        if (response.status === 401 || response.status === 403) {
            pubSub.publish("login");
        }
        return Promise.reject(error);
    }
);

/**
 * 上報捕獲的異常
 * @param { object } exception 異常信息對象
 */
function captureException(exception) {
    try {
        let user = JSON.parse(
            decodeURIComponent(getCookie("l_p_cc_0") || "{}")
        );
        const {
            session: {
                session: {
                    user: { clientSn },
                },
            },
        } = AppStateHOC.store.getState();
        const message = {
            ...exception,
            customer: user ? user.clientSn || "" : "",
            client: clientSn || "",
        };
        if (process.env.NODE_ENV === "production") {
            Sentry.captureException(message);
        } else {
            console.log(">>>> http captureException: ", message);
        }
    } catch (e) {}
}

// 保存作品
export const saveProject = (params) => {
    return axiosInstance
        .post(
            `${baseUrl}/website/vcCustomerProject/saveBaseCustomerProject`,
            params
        )
        .then((res) => {
            const data = res.data;
            if (data.success) {
                res.data.id = data.data;
            } else {
                captureException({
                    type: "error-create-project",
                    code: data.code || "",
                    message: data.message || "",
                });
            }
            return res.data;
        });
};

// 更新作品
export const updateProject = (params) => {
    const { id } = params;
    return axiosInstance
        .post(
            `${baseUrl}/website/vcCustomerProject/updateBaseCustomerProject`,
            params
        )
        .then((res) => {
            const data = res.data;
            if (data.success) {
                res.data.id = id;
            } else {
                captureException({
                    type: "error-update-project",
                    id: id,
                    code: data.code || "",
                    message: data.message || "",
                });
            }
            return res.data;
        });
};

// 分享社區
export const shareCommunity = (params) => {
    return axiosInstance.post(
        `${baseUrl}/website/community/project/share`,
        params
    );
};

// 加载作品信息
export const requestProjectDetail = (params) => {
    return axiosInstance.post(
        `${baseUrl}/index/vcShareProjectController/getCustomerProjectDetail`,
        params
    );
};

// 獲取自定義背景素材 JSON
export const getBackdrop = () => {
    return axiosInstance.get(`${baseUrl}/index/mc/sps3/backdrop`);
};

// 獲取自定義角色素材 JSON
export const getSprite = () => {
    return axiosInstance.get(`${baseUrl}/index/mc/sps3/sprite`);
};

// 獲取自定義造型素材 JSON
export const getCostume = () => {
    return axiosInstance.get(`${baseUrl}/index/mc/sps3/costume`);
};

// 獲取自定義聲音素材 JSON
export const getSound = () => {
    return axiosInstance.get(`${baseUrl}/index/mc/sps3/sound`);
};

export const getTag = () => {
    return axiosInstance.get(`https://programing.vipjr.com/index/mc/custom`);
};

// 加載定義角色素材
export const requestCustomerId = (params) => {
    return axiosInstance.post(
        `${baseUrl}/website/vcCustomerFocus/getCustomerId`,
        params
    );
};

// 加載作品
export const loadProject = (url) => {
    return axiosInstance.get(url, {
        responseType: "blob",
        withCredentials: false,
    });
};

// 下載作品驗證(只能下載自己的)
export const verifyDownload = (customerProjectId) => {
    return axiosInstance.get(
        `${baseUrl}/website/vcCustomerProject/checkAuthor/${customerProjectId}`
    );
};
